import { useDispatch } from "react-redux";

import { useMutation, useQueryClient } from "@tanstack/react-query";

import { apiThatThrows } from "containers/Request";
import { ApiResponse } from "types/api";

import { TiVoAppProvider } from "./types";
import { isProviderUnique } from "./utils";

export const useUpdateProvider = (id?: string) => {
  const dispatch = useDispatch();
  const queryClient = useQueryClient();

  return useMutation<
    ApiResponse<TiVoAppProvider>,
    Error,
    Partial<TiVoAppProvider>
  >({
    mutationFn: async (data) => {
      const unique = await isProviderUnique(id, data, dispatch);
      if (!unique) {
        throw new Error(
          "The provider is not unique. Please check the app label, the provider ID and the universal provider ID."
        );
      }
      return await dispatch(
        apiThatThrows.updateTiVoProvider.action({
          params: { id },
          options: {
            body: JSON.stringify({
              data: {
                type: "TiVoAppProvider",
                attributes: data,
              },
            }),
          },
        })
      );
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["providers"] });
      queryClient.invalidateQueries({ queryKey: ["provider", id] });
    },
  });
};
